"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const AWSource_1 = require("./AWSource");
class AWSourceAudio extends AWSource_1.AWSource {
    constructor() {
        super('audio');
        this.loop = true;
        this.dataRate = 0;
        this.codec = '';
        this.audioTracksCount = 0;
    }
}
exports.AWSourceAudio = AWSourceAudio;
AWSourceAudio.propFactory = Object.assign({}, AWSource_1.AWSource.propFactory);
